import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateEmployee as apiUpdate } from "../../api/apiEmployees";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useUpdateEmployee() {
    const navigate = useNavigate();
    const qc = useQueryClient();
    const { enqueueSnackbar } = useSnackbar();
    const { mutate: editEmployee, isPending: isUpdate, error } = useMutation({
        mutationFn: ({ req, id }) => apiUpdate(req, id),
        onSuccess: (r) => { enqueueSnackbar(r.message, { variant: "success" }); qc.invalidateQueries({ queryKey: ["employees"] }); navigate('/employees'); },
        onError: (err) => { enqueueSnackbar(getErrorMessageFromAxiosError(err), { variant: "error" }); },
    });
    return { editEmployee, isUpdate, error };
}
